import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { CustomEventIglu } from '@planone/bau365/feature-tracking';

import { Exhibitor } from '@planone/bau365/util-fair-data';

@Component({
  selector: 'bau365-exhibitor-section-contact',
  templateUrl: './section-contact.component.html',
  styleUrls: ['./section-contact.component.scss'],
})
export class SectionExhibitorContactComponent {
  @Input() exhibitor?: Exhibitor;
  @Input() showSendBusinessCard: boolean | undefined | null;

  @Output() linkClick: EventEmitter<{
    element: EventTarget | null;
    linkType: string;
    contactPersonId?: string;
    linkText?: string;
  }> = new EventEmitter<{
    element: EventTarget | null;
    linkType: string;
    contactPersonId?: string;
    linkText?: string;
  }>();
  @Output() sendBusinessCard = new EventEmitter<void>();

  get hasSocialMedia() {
    return (
      !!this.exhibitor?.social_media?.linked_in ||
      !!this.exhibitor?.social_media?.xing ||
      !!this.exhibitor?.social_media?.instagram ||
      !!this.exhibitor?.social_media?.facebook ||
      !!this.exhibitor?.social_media?.twitter ||
      !!this.exhibitor?.social_media?.youtube ||
      !!this.exhibitor?.social_media?.pinterest ||
      !!this.exhibitor?.social_media?.tiktok
    );
  }

  get hasEMail() {
    return !!this.exhibitor?.contact?.email;
  }

  snowplowIglu = CustomEventIglu;
  objectRef = Object;

  constructor(@Inject(LOCALE_ID) public locale: string) {}

  trackClick = (element: EventTarget | null, linkType: string, linkText?: string, contactPersonId?: string) =>
    this.linkClick.emit({ element, linkType, linkText, contactPersonId });
}
